/*
  The $10 book gift inside the UpCart cart drawer (launch night, Oct 7, 2026).
  snippets/kjm-drawer-gift.liquid prints the offer into <template id="kjm-drawer-gift-tpl">;
  this script moves one copy to the end of the drawer's scrolling body, under the items.

  UpCart redraws its drawer often (every cart change, every open), so a watcher puts the offer
  back whenever a redraw drops it. It is shown only while the drawer lists at least one item,
  and the form inside is the ordinary add-to-cart form: UpCart adds the books and refreshes the
  drawer itself, and without UpCart the form simply posts to the bag.
*/
(function () {
  var tpl = document.getElementById('kjm-drawer-gift-tpl');
  if (!tpl || !('content' in tpl) || !window.MutationObserver) return;

  var gift = null;
  var placing = false;

  function drawerBody() {
    return document.querySelector('#upCart .upcart-cart-body');
  }

  function hasItems(body) {
    return !!body.querySelector('.upcart-products-section .upcart-product-item');
  }

  function place() {
    if (placing) return;
    var body = drawerBody();
    if (!body) return;
    placing = true;
    try {
      if (!gift) {
        gift = tpl.content.firstElementChild.cloneNode(true);
      }
      if (!hasItems(body)) {
        if (gift.parentNode) gift.parentNode.removeChild(gift);
      } else if (gift.parentNode !== body || body.lastElementChild !== gift) {
        body.appendChild(gift);
      }
    } finally {
      placing = false;
    }
  }

  // A timer, not requestAnimationFrame: animation frames never run in a tab that is hidden.
  var queued = false;
  var watcher = new MutationObserver(function () {
    if (queued) return;
    queued = true;
    window.setTimeout(function () {
      queued = false;
      place();
    }, 30);
  });

  function start() {
    var root = document.getElementById('upCart');
    if (!root) return false;
    watcher.observe(root, { childList: true, subtree: true });
    place();
    return true;
  }

  if (!start()) {
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      if (start() || tries > 40) window.clearInterval(timer);
    }, 500);
  }
})();
